<template>
  <v-autocomplete
    v-model="selectedCategories"
    :label="$t('components.items.itemCategoriesAutocomplete.selectCategories')"
    :search-input.sync="categorySearch"
    @keypress.enter.native="addNewCategory()"
    color="primary"
    multiple
    :items="categoryOptions"
    item-text="category"
    item-value="category"
    chips
    hide-selected
    autocomplete="off"
    :auto-select-first="false"
    :hint="hint"
    persistent-hint
  >
    <template v-slot:selection="data">
      <v-chip v-bind="data.attrs" :input-value="data.selected">
        <v-icon class="mr-2" v-if="data.item.icon">{{ data.item.icon }}</v-icon>
        <span :class="{ 'text-capitalize': !!data.item.icon }">
          {{ data.item.category }}</span
        >
      </v-chip>
    </template>
    <template v-slot:item="{ item }">
      <v-icon v-if="item.icon" class="ml-1 mr-3">{{ item.icon }}</v-icon>
      <span v-else class="ml-10"></span>
      <span :class="{ 'text-capitalize': !!item.icon }">{{
        item.category
      }}</span>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title
            v-html="
              $t(
                'components.items.itemCategoriesAutocomplete.noResultsMatchingPressEnterToCreateANewOne',
                { categorySearch: categorySearch }
              )
            "
          >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import api from "@/utils/api";
import categories from "@/utils/categories.js";
export default {
  name: "ItemCategoriesAutocomplete",
  props: ["categories", "hint"],
  data: () => ({
    categorySearch: "",
    categoryOptions: [],
  }),
  computed: {
    selectedCategories: {
      get: function () {
        return this.categories;
      },
      set: function (value) {
        this.categorySearch = "";
        this.$emit("update:categories", value);
      },
    },
  },
  created() {
    this.categoryOptions = categories.categoryOptions();
    api.itemCategoriesAutocomplete().then((resp) => {
      this.categoryOptions.forEach((element) => {
        let indexToDelete = resp.data.findIndex(
          (item) => item === element.category
        );
        if (indexToDelete !== -1) {
          resp.data.splice(indexToDelete, 1);
        }
      });

      resp.data.forEach((element) => {
        //DELETE if "none" logic exist on backend
        if (element !== "none" && element !== "None") {
          this.categoryOptions.push({
            category: element,
            //  icon: "mdi-cancel"
          });
        }
      });
    });
  },
  methods: {
    addNewCategory() {
      this.categoryOptions.push({
        category: this.categorySearch,
        // icon: "mdi-cancel",
      });
      this.selectedCategories.push(this.categorySearch);
      this.categorySearch = "";
    },
  },
};
</script>
